var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrying3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM6.75 9C6.75 8.58579 7.08579 8.25 7.5 8.25H10.5C10.9142 8.25 11.25 8.58579 11.25 9C11.25 9.41421 10.9142 9.75 10.5 9.75H9.75V12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12V9.75H7.5C7.08579 9.75 6.75 9.41421 6.75 9ZM12.75 9C12.75 8.58579 13.0858 8.25 13.5 8.25H16.5C16.9142 8.25 17.25 8.58579 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75H15.75V12C15.75 12.4142 15.4142 12.75 15 12.75C14.5858 12.75 14.25 12.4142 14.25 12V9.75H13.5C13.0858 9.75 12.75 9.41421 12.75 9ZM12.6783 18.32C12.5016 18.6946 12.0547 18.855 11.68 18.6783C11.3054 18.5016 11.145 18.0547 11.3217 17.68C12.2743 15.6606 14.2914 14.25 16.6437 14.25C17.0579 14.25 17.3937 14.5858 17.3937 15C17.3937 15.4142 17.0579 15.75 16.6437 15.75C14.9134 15.75 13.4014 16.7871 12.6783 18.32Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrying3);
export default __webpack_public_path__ + "static/media/crying-3.5e8fd7b52f67c1a0e1d2764f8d7958ef.svg";
export { ForwardRef as ReactComponent };